import styled from 'styled-components'

import { media } from 'src/styles/media'
import { fontSize, fontWeight } from 'src/styles/fonts'
import { color } from 'src/styles'

export const ContentWrap = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100%;

  ${media.desktop} {
    max-width: 100rem;
    width: 100%;
    margin: auto;
  }
`

export const Title = styled.h2`
  font-size: ${fontSize.LARGE_XXXL};
  font-weight: ${fontWeight.EXTRA};
  color: ${color.GREYISH_BROWN};
  margin-left: 2rem;
`
